<div class="cool-off-widget" (click)="showNotificationModal()">
	<div class="flex justify-between">
		<div>
			<div class="title">{{ data.title }}</div>

			@if (data.status === COOL_OFF_TRADE_STATUSES.BLOCKED) {
				<p class="subtitle">{{ data.message_prompt }}</p>
			}
		</div>
		<div class="timer">{{ endTime | countdown_custom_format | async }}</div>
	</div>


	@if (progress$ | async; as progress) {
		<div class="progress">
			<bp-progress-indicator
				[value]="progress">
			</bp-progress-indicator>
		</div>
	}
</div>

